import { useEffect, useState } from 'react';
import { Api } from '../../componentes/Api';
import { Card, Col,Row, CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import Moment from "moment";
import DatePicker from "react-datepicker";
import * as XLSX from "xlsx"
import { saveAs } from "file-saver";
import * as moment from 'moment';



const modeloDatos = {
   amigosID:0,
      empresaID: 1,
       nombre: ''
    , telefono: "",
    sector: "",
    sexo:""
    , invitadoDe: "",
    fecha: new Date(),
     convertido: false,
      creadoPor: "",
    fechaCreado: new Date()

}
let Amigos_T = 0;
///// USESTATE DE FECHA (VARIABLE PARA MANEJAR LA FECHA) ////
let FechaControl = new Date();
const Amigos = () => {
    const [tabla, setTabla] = useState(modeloDatos);
    const [Listado, SetListado] = useState([]);
    const [ListaProd, SetListaProd] = useState([]);
    ///// USESTATE DE FECHA (VARIABLE PARA MANEJAR LA FECHA) ////
    const [fechaInicio, setFechaInicio] = useState(new Date());


    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);
    const [Visualizar, setVisualizar] = useState(false);
    const [VisualizarC, setVisualizarC] = useState(false);
    const [Fac, setFac] = useState([]);
    const [user, setUser] = useState(window.localStorage.getItem("sesion_usuario"))
    const handleChangef = (e) => {        
            setTabla({
                ...tabla,
                "fecha": e
            })
        }
    const handleChange = (e) => {
        if (e.target.name == "convertido" ) {
            let value = e.target.value === "true" ? true : false;
            setTabla({
                ...tabla,
                [e.target.name]: value
            })
        } else {

            setTabla({
                ...tabla,
                [e.target.name]: e.target.value
            })
        }
    }

    let correo = JSON.parse(user).correo;
   
    const Cam_F = (x) => {
          setFechaInicio(x)
        FechaControl = x;
    }

    /////// Ejemplo de como Formatear fecha
    /////// Moment(fechaInicio).format('YYYY-MM-DD')

    const obtenerDatos = async (x) => {
        let response = await fetch(Api + "Iglesia/ListaAmigos/" + Moment(x).format('YYYY-MM-DD') + "/" + correo);
        if (response.ok) {
            let data = await response.json()
            Amigos_T = data.length;
            SetListado(data)
            setPendiente(false)

        }
    }
    const ConfirmarCita = async (e) => {
        let response = await fetch(Api + "Iglesia/ConfirmarAmigo/" + e.amigosID + "/" + correo);

        if (response.ok) {
          //  toast.success("Proceso realizado")
        }
    }
    useEffect(() => {
        obtenerDatos(FechaControl);
    })
    useEffect(() => {
        obtenerDatos(FechaControl);

    }, [FechaControl])
    
    const InactivarDatos = async (id) => {
        let response = await fetch(Api + "SeguridadSaludMantenimiento/InactivarArticulos/" + id, { method: "DELETE" })
        if (response.ok) {
         //   toast.success("Proceso realizado")
            setPendiente(true)
            obtenerDatos();
        }
    }

   


    const NuevoAmigo = () => {
        setVerModal(!verModal);
        }

    const mostrarMensaje = () => {
        Swal.fire({
            title: 'ERROR',
            text: "No puedes guardar.  Favor validar si la informacion. ",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            //confirmButtonText: 'Si, continuar',
            cancelButtonText: 'volver'
        }).then((result) => {
            //alert(result.value)
            if (result.value) {


            }
        })

    }
    
    //// Guardar//////
    const guardarCambios = async () => {
        let response;
        
        if (tabla.convertido == 'false' || tabla.convertido == false) { tabla.convertido = Boolean(0) } else { tabla.convertido = Boolean(1) }
        if (tabla.amigosID == 0) {
            tabla.creadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "Iglesia/GuardarAmigo", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })

        } else {
            tabla.modificadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "Iglesia/EditarAmigos", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
        }

        if (response.ok) {

            Swal.fire(
                'Se Guardo!',
                'El amigo ha sido Guardad.',
                'success'
            )
            obtenerDatos(FechaControl);
            setTabla(modeloDatos);
            setVerModal(!verModal);

            let data1 = await response.json()

            if (data1 == false) {
                mostrarMensaje()
            } else {

                setTabla(modeloDatos)
                setVerModal(!verModal);
            }
        } else {
            mostrarMensaje()

        }
       
    }

    // Manejar ventanas modales////////

    const abrirEditarModal = (data, v) => {

        if (v == 1) {
            setVisualizar(!Visualizar);
        }
        setVisualizarC(true)
        setTabla(data);
        setVerModal(!verModal);
    }
    const cerrarModal = () => {
        setTabla(modeloDatos)
        setVerModal(false)
        setVisualizar(false)
        setVisualizarC(false)
    }

    ////Tabla/////

    const columns = [

        {
            name: 'Amigo ',
            selector: row => (<div>{row.nombre}
            </div>),
            sortable: true,
        },

      
        //{
        //    name: 'Convert',
        //    selector: row => row.confirmacionCita,
        //    sortable: true,
        //    cell: row => {
        //        let clase;
        //        clase = row.notificacionWhatsapp ? "badge badge-info p-2" : "badge badge-danger p-2"
        //        return (
        //            <span className={clase}>{row.notificacionWhatsapp ? "Si" : "No"}</span>
        //        )
        //    }
        //}, 
        //{
        //    name: 'Telefono',

        //    cell: row => row.telefono
        //},


        {
            name: '',
            cell: row => (
                <>
                    <Button color="info" size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row, 1)}
                    >
                        <i className="fas fa-eye"></i>
                    </Button>


                    <Button  color="primary" size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>




                </>
            ),
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '14px',
                fontWeight: 800,
            },
        },
        RowCells: {
            style: {
                fontSize: '14px',
                fontWeight: 800,
                paddingRight: '0px',
                paddingLeft: '0px',
                marginLeft: '0px',
                marginRight: '0px',
            },
        },
        headRow: {
            style: {
                  backgroundColor: "#eee",
            }
                    
        },
         rows: {
             style: {
                 fontSize: '13px',
                 paddingRight: '0px',             
                 paddingLeft: '0px',
                 marginLeft: '0px',
                 marginRight:'0px',
                 width: '120%' }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    const exportarExcel = () => {

        var lista = [];  
        for (var Listad of  Listado) {
        lista.push({
            Nombre: Listad.nombre, Telefono: Listad.telefono,
            Sector: Listad.sector, Sexo: Listad.sexo, InvitadoPor: Listad.invitadoDe,
            Fecha: Listad.fecha
        });
               }

        var wb = XLSX.utils.book_new();


        var ws = XLSX.utils.json_to_sheet(lista);
        XLSX.utils.book_append_sheet(wb, ws, "Reporte");
        XLSX.writeFile(wb, "Reporte de Amigos Servicio" + fechaInicio+ ".xlsx")
    }

    return (
        <>
            <Card>
                <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                    Lista de Amigos
                </CardHeader>
                <CardBody>

                    {/*  Ventana de seleccion y envio Whatsapp Y manejo Fechas*/}
                    <Row className="align-items-end">
                        <Col sm={3}>
                            <FormGroup>
                                <Button color="success" size="sm"
                                    onClick={() => NuevoAmigo()}
                                >Registrar Nuevo Amigo</Button>

                            </FormGroup>
                        </Col>

                        <Col sm={4}>

                            {/* Campo de fecha*/}
                            <FormGroup>
                                Fecha del Servicio:
                                <DatePicker
                                    className="form-control form-control-sm"
                                    selected={FechaControl}
                                    onChange={(date) => Cam_F(date)}
                                    dateFormat='dd/MM/yyyy'
                                />
                            </FormGroup>
                        </Col>

                        <Col sm={3}>
                            <FormGroup>
                                <Button color="success" size="sm"
                                    onClick={() => exportarExcel() }
                                >
                                   Enviar a Excel</Button>

                            </FormGroup>
                        </Col>

                        {/*Fecha: <Input bsSize="sm" type="date" name="fecha" onChange={handleChange} value={Moment(new Date).format('YYYY-MM-DD')} />*/}
                    </Row>
                    <hr></hr>
                    <h3>Total de Amigos: {Amigos_T }</h3>
{/*                    <DataTable*/}
{/*                        columns={columns}*/}
{/*                        data={Listado}*/}
{/*                        progressPending={pendiente}*/}
{/*//pagination*/}
{/*                        paginationComponentOptions={paginationComponentOptions}*/}
{/*                        customStyles={customStyles}*/}
                    {/*                    />*/}
                    <table className="table table-colabse">
                        <tr style={{ background: "#e4e9fa",color:"black"}}>
<th>Nombre</th>
                            <th>Telefono</th>
<th></th>
<th></th>
                        </tr>
                        {Listado.map(x => (
                            <tr key={x.amigosID} style={{ color: "black" }}>
                                <td>
                                    <b>   <div hidden={!x.convertido} style={{ background: "#c1ebc6", color: "black" }}>{x.nombre}</div>
                                    <div hidden={x.convertido}>{x.nombre}</div>

                                  </b></td>
                                <td>{x.telefono}</td>
                                <td>  <Button color="info" size="sm" className="mr-2"
                                    onClick={() => abrirEditarModal(x, 1)}
                                >
                                    <i className="fas fa-eye"></i>
                                </Button>

                                </td> <td>
                                    <Button  color="primary" size="sm" className="mr-2"
                                        onClick={() => abrirEditarModal(x)}
                                    >
                                        <i className="fas fa-pen-alt"></i>
                                    </Button></td>
                            </tr>
                        ))}
                    </table>
                </CardBody>
            </Card>

            <Modal isOpen={verModal}>
                <ModalHeader>
                    Mantenimiento de Amigos
                </ModalHeader>
                <ModalBody>
                    <Row>

                     
                        <Col sm={6}>
                            <FormGroup>
                                <Label>Nombre </Label>
                                <Input disabled={Visualizar} bsSize="sm" name="nombre" onChange={handleChange} value={tabla.nombre} />
                            </FormGroup>
                        </Col>   <Col sm={6}>
                            <FormGroup>
                                <Label>Telefono
                                    <i hidden={tabla.telefono.length == 10} style={{ color: "red" }} className="fas fa-exclamation-circle"></i>
                                    <i hidden={tabla.telefono.length != 10} style={{ color: "green" }} className="fas fa-check"></i>

                                </Label>
                                <Input disabled={Visualizar} maxlength="10" type="text" bsSize="sm" name="telefono" onChange={handleChange} value={tabla.telefono} />

                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={6}>
                            <FormGroup>
                                <Label>Sector </Label>

                                <Input disabled={Visualizar} bsSize="sm" name="sector" onChange={handleChange} value={tabla.sector} />

                            </FormGroup>
                        </Col>
                        <Col sm={6 }>
                        <FormGroup>
                            <Label>Invitado Por </Label>
                            <Input disabled={Visualizar} bsSize="sm"  name="invitadoDe" onChange={handleChange} value={tabla.invitadoDe} />
                        </FormGroup>

                        </Col>
                    </Row>

                    <Row>
                      
                        <Col sm={6}>
                            <FormGroup>
                                {/*  CAMPO FECHA CALENDARIO DE GOOGLE*/}
                                <Label>Fecha Servicio</Label>
                           <DatePicker
                                    className="form-control form-control-sm"
                                    selected={new Date(tabla.fecha)}
                                    onChange={handleChangef}
                                    dateFormat='dd/MM/yyyy'
                                />
                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup>
                                <Label>Sexo </Label>
<br/>
                                <Input disabled={Visualizar} type={"select"} name="sexo" onChange={handleChange} value={tabla.sexo} >
                                    <option value={"Femenino"}>Femenino</option>
                                    <option value={"Masculino"}>Masculino</option>
                                </Input>

                            </FormGroup>
                        </Col>

                    </Row>
                                      <Row hidden={!VisualizarC}>
                        <Col sm={4}>
                            <FormGroup>
                                <Label>Convertido</Label>

                                <Input disabled={Visualizar} bsSize="sm" type={"select"} name="convertido" onChange={handleChange} value={tabla.convertido} >
                                    <option value={true}>Si</option>
                                    <option value={false}>No </option>
                                </Input>
                            </FormGroup>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <div hidden={Visualizar}>  <Button hidden={tabla.nombre=="" } size="sm" color="primary"
                        onClick={guardarCambios}
                    >Guardar</Button></div>
                    <Button size="sm" color="danger"
                        onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>



        </>
    )

}
export default Amigos;